import { PERMISOS } from 'const/Permisos';
import * as yup from 'yup';

const schemaNuevaSucursal = isTienePermisos => {
  const schema = {
    nombreSucursal: yup
      .string()
      .min(3, 'El nombre es muy corto')
      .max(100, 'El nombre no puede ser tan largo')
      .required('Este campo es obligatorio'),

    region: yup
      .object()
      .when(['comuna', 'nombreVia'], ([comuna, nombreVia], schema) => {
        if (!comuna && !nombreVia) {
          return schema.nullable(); // Permitir que sea nulo cuando ambos campos están vacíos
        }
        return schema
          .typeError('Este campo es obligatorio')
          .required('Este campo es obligatorio');
      }),

    comuna: yup
      .object()
      .typeError('Este campo es obligatorio')
      .required('Este campo es obligatorio'),

    nombreVia: yup
      .string()
      .trim()
      .max(100, 'La cantidad máxima de caracteres es 100')
      .min(3, 'La cantidad mínima de caracteres es 3')
      .required('Es un campo obligatorio'),

    codigosTipoResiduo: yup
      .array()
      .test(
        'checked',
        'Debes seleccionar al menos un residuo',
        function (residuos) {
          if (residuos) {
            return residuos.some(residuo => residuo.checked);
          }
        }
      )
  };
  if (isTienePermisos(PERMISOS.administracionSucursales)) {
    schema.empresa = yup
      .object()
      .typeError('Este campo es obligatorio')
      .required('Este campo es obligatorio');
  }
  return yup.object().shape(schema);
};

export { schemaNuevaSucursal };
